module.exports = __webpack_public_path__ + "static/media/watch.050af253.png";